(() => {
  const attempted = new WeakMap();
  const retry = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.dataset.alphaImageFallbacks) return;
    let candidates;
    try { candidates = JSON.parse(image.dataset.alphaImageFallbacks); } catch { return; }
    if (!Array.isArray(candidates)) return;
    const seen = attempted.get(image) || new Set();
    const current = image.currentSrc || image.src;
    if (current) seen.add(current);
    attempted.set(image, seen);
    for (const candidate of candidates) {
      if (typeof candidate !== 'string' || !candidate.trim()) continue;
      let url;
      try { url = new URL(candidate, document.baseURI); } catch { continue; }
      if (url.protocol !== 'https:' || seen.has(url.href)) continue;
      seen.add(url.href);
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = url.href;
      return;
    }
  };
  document.addEventListener('error', (event) => retry(event.target), true);
  document.addEventListener('load', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.dataset.alphaImageFallbacks || !image.naturalWidth) return;
    if (image.dataset.alphaImageSizePending === 'true' || !image.hasAttribute('width') || !image.hasAttribute('height')) {
      image.width = image.naturalWidth;
      image.height = image.naturalHeight;
      image.dataset.artworkRatio = String(image.naturalWidth / image.naturalHeight);
      delete image.dataset.alphaImageSizePending;
    }
  }, true);
  const mount = () => {
    document.querySelectorAll('img[data-alpha-image-fallbacks]').forEach((image) => {
      if (image.complete && image.naturalWidth === 0 && image.getAttribute('src')) retry(image);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
